// File names for downloads: <name>.pdf, <name>_page3.png, ...

const pad = (n) => String(n).padStart(2, '0');

// 2026-10-10_14-32-05: sorts chronologically, no characters any file system minds.
export function timestampName(date) {
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `_${pad(date.getHours())}-${pad(date.getMinutes())}-${pad(date.getSeconds())}`
  );
}

// Makes whatever the user typed safe as a file name on Windows, macOS and Linux:
// runs of forbidden or control characters (with the spaces around them) become
// one underscore, surrounding
// dots, spaces and underscores are trimmed, and the length is capped.
// Returns '' if nothing usable is left (the caller then uses the default name).
export function sanitizeName(raw, maxLength = 100) {
  return String(raw ?? '')
    .replace(/\s*[\\/:*?"<>|\u0000-\u001f\u007f]+\s*/g, '_')
    .replace(/\s+/g, ' ')
    .replace(/^[ ._]+|[ ._]+$/g, '')
    .slice(0, maxLength)
    .replace(/[ ._]+$/g, '');
}

// The base name to use: the typed name, else the default.
export function baseName(typed, defaultName) {
  return sanitizeName(typed) || defaultName;
}

export const fileNames = {
  pdf: (base) => `${base}.pdf`,
  png: (base, page) => `${base}_page${page}.png`,
  text: (base) => `${base}.txt`,
  rawAll: (base) => `${base}.bin`,
  rawTransfer: (base, n) => `${base}_transfer${n}.bin`,
  wire: (base) => `${base}.wire.bin`,
  replay: (base) => `${base}_replay.d64`,
};
